(function () {
  'use strict';
  if (window.SmartWeeklyClock) return;
  var formatter;
  var cached;
  try {
    formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Los_Angeles', year: 'numeric', month: '2-digit',
      day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
    });
  } catch (error) { return; }

  function localStamp(instant) {
    var values = {};
    formatter.formatToParts(new Date(instant)).forEach(function (part) {
      if (part.type !== 'literal') values[part.type] = Number(part.value);
    });
    return Date.UTC(values.year, values.month - 1, values.day,
      values.hour % 24, values.minute, values.second);
  }

  function toInstant(stamp) {
    var guess = stamp;
    for (var i = 0; i < 3; i += 1) {
      var correction = stamp - localStamp(guess);
      guess += correction;
      if (!correction) break;
    }
    return guess;
  }

  function getCycle(now) {
    now = now == null ? Date.now() : Number(now);
    if (!Number.isFinite(now)) return null;
    if (cached && now >= cached.start && now < cached.end) return cached;
    var local = new Date(localStamp(now));
    var day = Date.UTC(local.getUTCFullYear(), local.getUTCMonth(), local.getUTCDate());
    var daysToFriday = (5 - local.getUTCDay() + 7) % 7 || 7;
    var endLocal = day + daysToFriday * 86400000;
    cached = { start: toInstant(endLocal - 7 * 86400000), end: toInstant(endLocal) };
    return cached;
  }

  window.SmartWeeklyClock = { getCycle: getCycle };
})();

(function () {
  'use strict';

  function formatCampaignEnd(endDate) {
    try {
      return 'Ends ' + new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/New_York',
        month: 'short',
        day: 'numeric'
      }).format(endDate);
    } catch (error) {
      return '';
    }
  }

  function bindProductCards(scope) {
    (scope || document).querySelectorAll('[data-smart-product-card-link]').forEach(function (card) {
      if (card.dataset.smartProductCardBound === 'true') return;

      card.addEventListener('click', function (event) {
        if (event.target.closest('a, button, input, select, textarea, label, form')) return;
        var url = card.getAttribute('data-smart-product-card-link');
        if (url) window.location.href = url;
      });

      card.dataset.smartProductCardBound = 'true';
    });
  }

  function bindCampaignBadges(scope) {
    (scope || document).querySelectorAll('[data-smart-campaign-badges][data-end-at]').forEach(function (badges) {
      if (badges.dataset.smartCampaignBadgesBound === 'true') return;

      var weekly = badges.getAttribute('data-smart-countdown-mode') === 'weekly';
      var cycle = weekly && window.SmartWeeklyClock && window.SmartWeeklyClock.getCycle();
      if (weekly && !cycle) return;
      var endDate = weekly ? new Date(cycle.end) : new Date(badges.getAttribute('data-end-at') || '');
      if (isNaN(endDate.getTime())) return;

      var urgency = badges.querySelector('[data-smart-campaign-urgency]');
      var saving = badges.querySelector('.smart-product-card__campaign-ribbon--saving');

      if (!weekly && urgency && urgency.hasAttribute('data-smart-campaign-auto-label')) {
        var endLabel = formatCampaignEnd(endDate);
        if (endLabel) urgency.textContent = endLabel;
        if (saving) {
          badges.setAttribute('aria-label', urgency.textContent.trim() + '; ' + saving.textContent.trim());
        }
      }

      var timerId = null;
      var destroyed = false;

      function destroy() {
        destroyed = true;
        if (timerId) window.clearTimeout(timerId);
        document.removeEventListener('visibilitychange', sync);
        window.removeEventListener('pageshow', sync);
        delete badges.dataset.smartCampaignBadgesBound;
      }

      function expireUrgency() {
        if (destroyed || !badges.isConnected) { destroy(); return; }
        if (weekly) {
          endDate = new Date(window.SmartWeeklyClock.getCycle().end);
          badges.dataset.endAt = endDate.toISOString();
          if (urgency) urgency.hidden = false;
          badges.classList.remove('is-expired');
        }
        var remaining = endDate.getTime() - Date.now();
        if (remaining > 0) {
          timerId = window.setTimeout(expireUrgency, Math.min(remaining, 2147483647));
          return;
        }

        if (urgency) urgency.hidden = true;
        badges.classList.add('is-expired');
        if (saving) badges.setAttribute('aria-label', saving.textContent.trim().toLowerCase());
      }

      function sync() {
        if (timerId) window.clearTimeout(timerId);
        timerId = null;
        if (!document.hidden && !destroyed) expireUrgency();
      }

      badges.dataset.smartCampaignBadgesBound = 'true';
      badges._smartCampaignDestroy = destroy;
      document.addEventListener('visibilitychange', sync);
      window.addEventListener('pageshow', sync);
      sync();
    });
  }

  function init(scope) {
    bindProductCards(scope);
    bindCampaignBadges(scope);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-smart-campaign-badges]').forEach(function (badges) {
      if (badges._smartCampaignDestroy) badges._smartCampaignDestroy();
    });
  });
})();
